import { createRouter, RouterProvider as TanstackRouterProvider } from "@tanstack/react-router";
import type React from "react";
import { Suspense } from "react";
import { routeTree } from "../../routeTree.gen.ts";
import SzBackdrop from "../../ui/components/UISharedConstructors/Loading/SzBackDrop.tsx";
import { queryClient } from "./SzQueryClientProvider.tsx";

const router = createRouter({
  routeTree: routeTree,
  context: {
    queryClient: queryClient,
  },
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export const STALE_TIME = 5 * 1000 * 60;

/**
 * This is the `RouterProvider` for the whole app
 * if you need to extend or modify the context do so in `router` and in `IMMRouterContext` interface that is in the `__root.tsx` route within routes folder
 * in here the prefetched user is being passed to the router context
 *
 * if you want to know more about router context visit [TanStack Docs on Router Context](https://tanstack.com/router/latest/docs/framework/react/guide/router-context)
 *
 * @constructor
 */
const RouterProvider: React.FC = () => {
  return (
    <Suspense fallback={<SzBackdrop message="načítám informace o přihlášeném uživateli"/>}>
      <TanstackRouterProvider router={router}/>
    </Suspense>
  );
};

export default RouterProvider;
